import React, { useState } from "react";
import {
  PAGE_CA_ASSESSEE,
  PAGE_CA_ASSESSOR,
  PAGE_FGD_ASSESSEE,
  PAGE_FGD_ASSESSOR,
  PAGE_INTERVIEW_ASSESSEE,
  PAGE_INTERVIEW_ASSESSOR,
  PAGE_LGD_ASSESSEE,
  PAGE_LGD_ASSESSOR,
  PAGE_PRESENTASI_ASSESSEE,
  PAGE_PRESENTASI_ASSESSOR,
  PAGE_ROLEPLAY_ASSESSEE,
  PAGE_ROLEPLAY_ASSESSOR,
} from "../../general/constants/uiModeConstans";
import { useParams } from "react-router-dom";
import InterviewAssessorView from "./views/parts/InterviewAssessorView";
import InterviewAssesseeView from "./views/parts/InterviewAssesseeView";
import LGDAssessorView from "./views/parts/LGDAssessorView";
import LGDAssesseeView from "./views/parts/LGDAssesseeView";
import FGDAssessorView from "./views/parts/FGDAssessorView";
import FGDAssesseeView from "./views/parts/FGDAssesseeView";
import PresentasiAssessorView from "./views/parts/PresentasiAssessorView";
import PresentasiAssesseeView from "./views/parts/PresentasiAssesseeView";
import CameraAndAudioCheckingView from "./views/parts/CameraAndAudioCheckingView";
import { useSelector } from "react-redux";
import SessionEndView from "./views/parts/SessionEndView";
import { useEffect } from "react";
import SessionLeaveView from "./views/parts/SessionLeaveView";
import RolePlayAssessorView from "./views/parts/RolePlayAssessorView";
import RolePlayAssesseeView from "./views/parts/RolePlayAssesseeView";
import CaAssessorView from "./views/parts/CaAssessorView";
import CaAssesseeView from "./views/parts/CaAssesseeView";
import AlertSessionLayout from "../../general/components/Alert/AlertSessionLayout";

export const getPageAkses = (val) => {
  switch (val) {
    case PAGE_INTERVIEW_ASSESSOR:
      return <InterviewAssessorView />;
    case PAGE_INTERVIEW_ASSESSEE:
      return <InterviewAssesseeView />;
    case PAGE_LGD_ASSESSOR:
      return <LGDAssessorView />;
    case PAGE_LGD_ASSESSEE:
      return <LGDAssesseeView />;
    case PAGE_FGD_ASSESSOR:
      return <FGDAssessorView />;
    case PAGE_FGD_ASSESSEE:
      return <FGDAssesseeView />;
    case PAGE_PRESENTASI_ASSESSOR:
      return <PresentasiAssessorView />;
    case PAGE_PRESENTASI_ASSESSEE:
      return <PresentasiAssesseeView />;
    case PAGE_ROLEPLAY_ASSESSOR:
      return <RolePlayAssessorView />;
    case PAGE_ROLEPLAY_ASSESSEE:
      return <RolePlayAssesseeView />;
    case PAGE_CA_ASSESSOR:
      return <CaAssessorView />;
    case PAGE_CA_ASSESSEE:
      return <CaAssesseeView />;
    default:
      return;
  }
};

export default function SessionMethodVideoModul() {
  let { uiMode, sessionName } = useParams();
  const [isRoomOpen, setIsRoomOpen] = useState(true);
  const [isHold, setIsHold] = useState(true);
  const storeRoomStatus = useSelector((state) => state.smvm_room_status);
  const storeUserLeave = useSelector((state) => state.smvm_user_leave);
  const [userLeave, setUserLeave] = useState(false);
  useEffect(() => {
    if (storeRoomStatus.success && storeRoomStatus.roomOpen == false) {
      setIsRoomOpen(false);
    }
  }, [storeRoomStatus]);
  useEffect(() => {
    console.log("triger end leave s", storeUserLeave);
    if (storeUserLeave?.success && storeUserLeave?.leave == true) {
      setUserLeave(true);
    }
  }, [storeUserLeave]);
  return (
    <>
      {userLeave == true ? (
        <SessionLeaveView />
      ) : (
        <>
          {isRoomOpen ? (
            <>
              {isHold ? (
                <CameraAndAudioCheckingView
                  setIsHold={() => setIsHold(false)}
                />
              ) : (
                <div className="bg-black min-h-screen">
                  {getPageAkses(uiMode)}
                  <AlertSessionLayout />
                </div>
              )}
            </>
          ) : (
            <>
              <SessionEndView />{" "}
            </>
          )}
        </>
      )}
    </>
  );
}
